import Papa from "papaparse";

import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { LogsData } from "modules/AppointmentDetails/components/Logs/components";

const papaConfig = {
  delimiter: ",",
  header: true,
  skipEmptyLines: true
};

const parseData = (log: string) => {
  const csvWithHeaders = "time,user_id,user_name,affected_element,affected_element_id,appointment_id,description\n" + (log || "");
  const parsedData = Papa.parse<LogsData>(csvWithHeaders, papaConfig);
  return [...parsedData.data].sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());
};

export const useLogs = (appointment_id: number) =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.logs,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { appointment_id }, baseUrl)).data.log,
    select: parseData,
    enabled: false
  });
